import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import {
  HomeOutlined,
  HomeFilled,
  AppstoreOutlined,
  AppstoreFilled,
  ShopOutlined,
  ShopFilled,
  OrderedListOutlined,
} from '@ant-design/icons';
import { useAuth } from '@core/hooks/useAuth';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileTabBarDefault() {
  const t = useCopy();
  const { isAuthenticated } = useAuth();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.sm;
  const { pathname } = useLocation();

  if (!isMobile) return null;

  const handleTabClick = (e, tab) => {
    if (tab.to === '/orders' && !isAuthenticated) {
      e.preventDefault();
      window.dispatchEvent(
        new CustomEvent('open-auth-modal', {
          detail: { mode: 'login', redirect: '/orders' },
        }),
      );
    }
  };

  const tabs = [
    {
      to: '/',
      label: t('home', 'Home'),
      icon: <HomeOutlined />,
      activeIcon: <HomeFilled />,
    },
    {
      to: '/categories',
      label: t('category', 'Category'),
      icon: <AppstoreOutlined />,
      activeIcon: <AppstoreFilled />,
    },
    {
      to: '/catalog',
      label: t('shop', 'Shop'),
      icon: <ShopOutlined />,
      activeIcon: <ShopFilled />,
    },
    {
      to: '/orders',
      label: t('orders', 'Orders'),
      icon: <OrderedListOutlined />,
      activeIcon: <OrderedListOutlined />,
    },
  ];

  return (
    <nav className="default-mobile-tabs" aria-label="Primary Mobile Navigation">
      {tabs.map((tab) => {
        let isActive = false;
        if (tab.to === '/') {
          isActive = pathname === '/';
        } else if (tab.to === '/categories') {
          isActive = pathname.startsWith('/categories');
        } else if (tab.to === '/catalog') {
          isActive = pathname.startsWith('/catalog');
        } else {
          isActive = pathname.startsWith(tab.to);
        }

        return (
          <Link
            key={tab.to}
            to={tab.to}
            onClick={(e) => handleTabClick(e, tab)}
            className={isActive ? 'default-mobile-tab is-active' : 'default-mobile-tab'}
          >
            <span className="default-mobile-tab-icon">{isActive ? tab.activeIcon : tab.icon}</span>
            <span className="default-mobile-tab-label">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
